import cookieStorage from 'helpers/cookieStorage';

import { REFERRER } from 'store/consts';

const isHostname = (value: string) => {
  try {
    return new URL(`https://${value}`).hostname === value.toLowerCase();
  } catch {
    return false;
  }
};

export const getReferrerFromSearch = (search: string): string | null => {
  const referrer = new URLSearchParams(search).get('referrer');

  return referrer && isHostname(referrer) ? referrer.toLowerCase() : null;
};

export const storeReferrer = (referrer: string) => {
  cookieStorage.setItem(REFERRER, referrer, { expires: 2 });
};
